import React, { useState } from "react";
import Select from "react-select";

const InvoiceLineItem = ({ lineItem, updateLineItem, donations }) => {
  const [deleting, setDeleting] = useState(false);

  let donation;

  if (!lineItem.donation_id) {
    donation = donations[0];
    lineItem.donation_id = donations[0].id
  } else {
    donation = donations.find(element => element.id == lineItem.donation_id);
  }

  const totalDonation = +donation.unit_cost * +lineItem.quantity;
  const totalTax = +lineItem.tax;
  const totalLineItem = totalDonation + totalTax;


  return (
      <table className="in-show-tb">
        <tr style={{overflow: 'auto'}}>
          <td className="t-header-one" style={{ width: '45%' }}>{donation.name} | {donation.description} | ${parseFloat(donation.unit_cost).toFixed(2)} {donation.currency}</td>
          <td className="t-header-tw" style={{ width: '20%' }}>{lineItem.beneficiary.name}</td>
          <td className="t-header-tw" style={{ width: '10%' }}>{lineItem.quantity}</td>
          <td className="t-header-tw" style={{ width: '10%' }}>{lineItem.tax}</td>
          <td className="t-header-tw" style={{ width: '15%' }}><strong>${parseFloat(totalLineItem).toFixed(2)} {donation.currency}</strong></td>
        </tr>
      </table>
  );
};

export default InvoiceLineItem;
